<template>
  <div v-if="aberto" class="modal-logs-sala">
    <div class="modal-logs-sala__overlay" @click.self="fechar">
      <div class="modal-logs-sala__container">
        <header class="modal-logs-sala__header">
          <h2>Logs da Sala: {{ nomeSala }}</h2>
          <button type="button" class="modal-logs-sala__close" @click="fechar">&times;</button>
        </header>

        <div class="modal-logs-sala__body">
          <div v-if="loading" class="modal-logs-sala__state">Carregando logs...</div>
          <div v-else-if="loadFailed" class="modal-logs-sala__state modal-logs-sala__state--error">
            Não foi possível carregar os dados.
          </div>
          <div v-else-if="dados.length === 0" class="modal-logs-sala__state">
            Nenhum log encontrado para esta sala.
          </div>
          <div v-else class="modal-logs-sala__table-wrapper">
            <table class="modal-logs-sala__table">
              <thead>
                <tr>
                  <!-- <th>ID</th> -->
                  <th>Data/Hora</th>
                  <th>Estado</th>
                  <th>Primário</th>
                  <th>Secundário</th>
                  <th>Primário na Sala</th>
                  <th>Secundário na Sala</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in dados" :key="log.id">
                  <!-- <td>{{ log.id }}</td> -->
                  <td>{{ formatarData(log.createdAt) }}</td>
                  <td>{{ formatSalaStatus(resolveSalaEstado(log)) }}</td>
                  <td>{{ log.uidPrimario || 'N/A' }}</td>
                  <td>{{ log.uidSecundario || 'N/A' }}</td>
                  <td>{{ log.primarioNaSala === log.uidPrimario ? 'Sim' : 'Não' }}</td>
                  <td>{{ log.secundarioNaSala === log.uidSecundario ? 'Sim' : 'Não' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import salasService from '../service/salas.service';
import { showErrorToast } from '../service/toast.service';
import { formatSalaStatus, resolveSalaEstado } from '../utils/salas.utils';

export default {
  name: 'ModalLogsSala',

  props: {
    aberto: {
      type: Boolean,
      required: true
    },
    salaId: {
      type: Number,
      default: null
    },
    nomeSala: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      loadFailed: false,
      dados: []
    };
  },

  watch: {
    aberto(novoValor) {
      if (novoValor && this.salaId) {
        this.carregarDados();
      } else if (!novoValor) {
        this.limparDados();
      }
    }
  },

  methods: {
    formatSalaStatus,
    resolveSalaEstado,

    async carregarDados() {
      this.loading = true;
      this.loadFailed = false;

      try {
        this.dados = await salasService.getLogsBySala(this.salaId);
      } catch (err) {
        showErrorToast('Não foi possível carregar os logs desta sala.');
        this.loadFailed = true;
      } finally {
        this.loading = false;
      }
    },

    fechar() {
      this.$emit('fechar');
    },

    limparDados() {
      this.loading = false;
      this.loadFailed = false;
      this.dados = [];
    },

    formatarData(data) {
      if (!data) return 'N/A';
      return new Date(data).toLocaleString('pt-BR');
    }
  }
};
</script>

<style scoped src="./ModalLogsSala.css"></style>
